import { isValid, parseISO } from 'date-fns';

/**
 * Normalises a project date coming from the Projects sync.
 *
 * Returns `undefined` when the source system has no date set — including
 * null/empty strings and the sentinel default dates (year <= 1900) that the
 * PSA API returns for unset DateTime fields — so the UI can omit the value
 * instead of rendering a fabricated one.
 */
export function normaliseProjectDate(raw: string | null | undefined): string | undefined {
  if (raw == null) return undefined;
  const trimmed = raw.trim();
  if (trimmed.length === 0) return undefined;
  const parsed = parseISO(trimmed);
  if (!isValid(parsed) || parsed.getFullYear() <= 1900) return undefined;
  return trimmed;
}

/** Parses a project date, returning `null` when it is unset or unparseable. */
export function parseProjectDate(raw: string | null | undefined): Date | null {
  const normalised = normaliseProjectDate(raw);
  if (!normalised) return null;
  return parseISO(normalised);
}
